export const organicSearchTypes = [
    {
        id: null,
        text: "analysis.competitors.search.organic.table.searchtype.all",
        tooltipText: "analysis.competitors.search.organic.table.searchtype.all.tooltip",
    },
    {
        id: "IsRelatedQuestions",
        text: "analysis.competitors.search.organic.table.searchtype.questions",
        tooltipText: "analysis.competitors.search.organic.table.searchtype.questions.tooltip",
    },
    {
        id: "IsNews",
        text: "analysis.competitors.search.organic.table.searchtype.news",
        tooltipText: "analysis.competitors.search.organic.table.searchtype.news.tooltip",
    },
];

export const paidSearchTypes = [
    {
        id: null,
        text: "analysis.competitors.search.paid.table.searchtype.all",
        tooltipText: "analysis.competitors.search.paid.table.searchtype.all.tooltip",
    },
    {
        id: "IsPpc",
        text: "analysis.competitors.search.paid.table.searchtype.searchads",
        tooltipText: "analysis.competitors.search.paid.table.searchtype.searchads.tooltip",
    },
    {
        id: "IsPla",
        text: "analysis.competitors.search.paid.table.searchtype.pla",
        tooltipText: "analysis.competitors.search.paid.table.searchtype.pla.tooltip",
    },
];
